const CheckboxGroup = ({ value, onChange, options, className, type, hideSelectedBorder }) => {
    value = value || [];

    function isChecked(thisValue) {
        if (type === 'radio') {
            return value === thisValue;
        } else {
            return value.indexOf(thisValue) > -1;
        }
    }

    function toggle(thisValue) {
        if (type === 'radio') {
            onChange(thisValue);
        } else {
            if (isChecked(thisValue)) {
                onChange(value.filter(v => v !== thisValue));
            } else {
                onChange([...value, thisValue]);
            }
        }
    }

    return (
        <div
            className={`${className} grid grid-cols-2 sm:grid-cols-3 gap-x-2 gap-y-2`}
        >
            {options.map(opt => (
                <label
                    key={opt.value}
                    className={`border flex items-center whitespace-nowrap rounded-lg px-3 py-1.5 ${isChecked(opt.value) && !hideSelectedBorder ? 'border-primary-700' : ''}`}
                >
                    <input
                        type={type || 'checkbox'}
                        className="mr-2"
                        value={opt.value}
                        checked={isChecked(opt.value)}
                        onChange={() => toggle(opt.value)}
                    />
                    {opt.label}
                </label>
            ))}
        </div>
    );
};

export default CheckboxGroup;
